<template>
<div class="chapter">
<div class="inner_page">
<h1 class="plm_hd"><a href="#/Text/PL_contents">Abbreviations</a></h1>
<p class="abb_fo">AB – Anchor Bible</p>
<p class="abb_fo">ALASPM – Abhandlungen zur Literatur Alt-Syrien-Palästinas und Mesopotamiens</p>
<p class="abb_fo">ANE – Ancient Near East(ern)</p>
<p class="abb_fo"><em class="italic">ANEP</em> – James Pritchard, <em class="italic">The Ancient Near East: An Anthology of Texts and Pictures</em>, Princeton: Princeton University Press, 1969</p>
<p class="abb_fo"><em class="italic">ANET</em> – <em class="italic">﻿Ancient Near Eastern Texts Relating to the Old Testament</em>, ed. James Pritchard, 3rd edn, Princeton: Princeton University Press, 1969</p>
<p class="abb_fo">ATANT – Abhandlungen zur Theologie des Alten und Neuen Testaments</p>
<p class="abb_fo">BCOTWP – Baker Commentary on the Old Testament Wisdom and Psalms</p>
<p class="abb_fo">BDB – Francis Brown, S. R. Driver and Charles Briggs, <em class="italic">A Hebrew and English Lexicon of the Old Testament</em>, Peabody: Hendrickson, 1996</p>
<p class="abb_fo">BETL – Bibliotheca ephemeridum theologicarum lovaniensium</p>
<p class="abb_fo"><em class="italic">BHS</em> – <em class="italic">Biblia Hebraica Stuttgartensia</em>, ed. K. Elliger and W. Rudolph, Stuttgart: Deutsche ﻿Bibelgesellschaft, 1983</p>
<p class="abb_fo"><em class="italic">Bib – Biblica</em></p>
<p class="abb_fo"><em class="italic">BibInt</em> – <em class="italic">Biblical Interpretation </em></p>
<p class="abb_fo"><em class="italic">BSac – Bibliotheca sacra</em></p>
<p class="abb_fo">BZAW – Beihefte zur Zeitschrift für die alttestamentliche Wissenschaft</p>
<p class="abb_fo">CAT – Commentaire de l’Ancien Testament<em class="italic"> </em></p>
<p class="abb_fo"><em class="italic">CBQ – Catholic Biblical Quarterly</em></p>
<p class="abb_fo">ConBNT – Coniectanea biblica: New Testament Series</p>
<p class="abb_fo">﻿<em class="italic">COS</em> – <em class="italic">The Context of Scripture: Canonical Compositions, Monumental Inscriptions and Archival Documents from the Biblical World</em>, ed. William Hallo and K. Lawson Younger, Leiden: Brill, 2003</p>
<p class="abb_fo"><em class="italic">DOTWPW – Dictionary of Old Testament: Wisdom, Poetry and Writings</em>, ed. Tremper Longman and Peter Enns, Downers Grove: IVP Academic, 2008</p>
<p class="abb_fo"><span class="smallcaps">esv</span> – English Standard Version</p>
<p class="abb_fo"><em class="italic">ExAud – Ex auditu </em></p>
<p class="abb_fo">﻿GKC – Wilhelm Gesenius and E. Kautzsch, <em class="italic">Gesenius’ Hebrew Grammar</em>, Oxford: Clarendon, 1910</p>
<p class="abb_fo">GUS – Gorgias Ugaritic Studies</p>
<p class="abb_fo"><em class="italic">HALOT – </em>Ludwig ﻿Koehler and Walter Baumgartner, <em class="italic">The Hebrew and Aramaic Lexicon of the Old Testament</em>, Leiden: Brill, 2001</p>
<p class="abb_fo">﻿<em class="italic">HBT – Horizons in Biblical Theology </em></p>
<p class="abb_fo"><em class="italic">Int – Interpretation </em></p>
<p class="abb_fo"><em class="italic">JAOS – Journal of the American Oriental Society </em></p>
<p class="abb_fo"><em class="italic">JBL – Journal of Biblical Literature </em></p>
<p class="abb_fo">J-M – Paul Joüon and Takamitsu Muraoka, <em class="italic">A Grammar of Biblical Hebrew</em>, 2nd edn, SubBi 27, Rome: Pontifical Biblical Institute, 2013</p>
<p class="abb_fo"><em class="italic">JNSL – Journal of Northwest Semitic Languages</em></p>
<p class="abb_fo"><em class="italic">JSOT – Journal for the Study of the Old Testament </em></p>
<p class="abb_fo">JSOTSup – Journal for the Study of the Old Testament: ﻿Supplement Series<em class="italic"> </em></p>
<p class="abb_fo"><em class="italic">JTI – Journal of Theological Interpretation</em></p>
<p class="abb_fo">km – kilometres</p>
<p class="abb_fo"><em class="italic">KTU – Keilalphabetische Texte aus Ugarit</em>, ed. Manfried Dietrich, Oswald Loretz and Joaquin Sanmartin, ﻿Münster: Ugarit-Verlag, 1995</p>
<p class="abb_fo"><span class="smallcaps">lxx – </span>Septuagint</p>
<p class="abb_fo">mi – miles</p>
<p class="abb_fo"><span class="smallcaps">mt</span> – Masoretic Text</p>
<p class="abb_fo">NABC – New American Bible Commentary</p>
<p class="abb_fo">NAC – New American Commentary</p>
<p class="abb_fo">NCB – New Century Bible</p>
<p class="abb_fo"><em class="italic">NDBT – New Dictionary of Biblical Theology</em>, ed. T. Desmond Alexander ﻿et al., Leicester: Inter-Varsity Press; Downers Grove: InterVarsity ﻿Press, 2000</p>
<p class="abb_fo"><em class="italic">NIB – The New Interpreter’s Bible</em>, ed. L. Keck, 10 vols., Nashville: ﻿Abingdon, 1996</p>
<p class="abb_fo">NICOT – New International Commentary on the Old Testament<em class="italic"> </em></p>
<p class="abb_fo"><em class="italic">NIDOTTE – New International Dictionary of Old Testament Theology and Exegesis</em>, ed. Willem VanGemeren, 5 vols., Grand Rapids: Zondervan, 1996</p>
<p class="abb_fo"><span class="smallcaps">niv</span> – New International Version</p>
<p class="abb_fo">NIVAC – New International Version Application Commentary</p>
<p class="abb_fo">NSBT – New Studies in Biblical Theology</p>
<p class="abb_fo">NT – New Testament</p>
<p class="abb_fo"><em class="italic">﻿</em>OT – Old Testament</p>
<p class="abb_fo">OTL – Old Testament Literature</p>
<p class="abb_fo"><em class="italic">PRSt – Perspectives in Religious Studies </em></p>
<p class="abb_fo"><em class="italic">RB – Revue biblique</em></p>
<p class="abb_fo">SBL – Studies in Biblical Literature</p>
<p class="abb_fo">SHBC – Smyth &amp; Helwys Bible Commentary</p>
<p class="abb_fo">SOTBT – Studies in Old Testament Biblical Theology</p>
<p class="abb_fo">﻿﻿SubBi – Subsidia biblica<em class="italic"> </em></p>
<p class="abb_fo">THC – Two Horizons Commentary<em class="italic"> </em></p>
<p class="abb_fo"><em class="italic">Them</em> – <em class="italic">Themelios </em></p>
<p class="abb_fo"><em class="italic">ThTo – Theology Today</em></p>
<p class="abb_fo"><em class="italic">TJ – Trinity Journal</em></p>
<p class="abb_fo">TOTC – Tyndale Old Testament Commentary</p>
<p class="abb_fo">tr. – translation, translated</p>
<p class="abb_fo"><em class="italic">TynBul – Tyndale Bulletin</em></p>
<p class="abb_fo"><em class="italic">VT – Vetus Testamentum </em></p>
<p class="abb_fo">WBC – Word Biblical Commentary</p>
<p class="abb_fo">WMANT – Wissenschaftliche Monographien zum Alten and Neuen Testament</p>
<p class="abb_fo">WOC – Bruce Waltke and Michael O’Connor, <em class="italic">An Introduction to Biblical Hebrew Syntax</em>, Winona Lake: Eisenbrauns, 1990</p>
<p class="abb_fo"><em class="italic">WTJ – Westminster Theological Journal </em></p>
<p class="abb_fo"><em class="italic">ZAW – Zeitschrift für die alttestamentliche Wissenschaft </em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// PL_abbrev.vue?1618cb66